module.exports = __webpack_public_path__ + "img/dice-icon-default.ffeff799.svg";